module.exports = __webpack_public_path__ + "jab/media/data-warning.49e0f143.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/data-warning.svg
// module id = 132
// module chunks = 0